import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import FormSpinner from '../../../../../components/FormSpinner';
import { RMSFabIconButton, RMSIconButton, RMSButton } from '../../buttons/index';
import clsx from 'clsx';

const RMSCommonDialog = ({
  open,
  title,
  children,
  onClose,
  onSave,
  saveButton = {
    show: true,
    type: 'fab-icon',
    label: undefined,
    color: 'secondary',
    className: '',
    icon: undefined,
    variant: 'contained',
  },
  cancelButton = {
    show: true,
    type: 'fab-icon',
    label: undefined,
    color: 'secondary',
    className: '',
    icon: undefined,
    variant: 'contained',
  },
  saveDisabled = false,
  customButtons = [],
  closeOnBackdropClick = true,
  maxWidth = 'md',
  fullWidth = true,
  loading = false,
  className = '',
  dialogClassName = '',
  headerActions,
}) => {
  const handleCancelClick = () => {
    onClose && onClose();
  };

  const handleDialogClose = (_event, reason) => {
    if (!closeOnBackdropClick && reason === 'backdropClick') {
      return;
    }
    handleCancelClick();
  };

  const renderSaveButton = () => {
    if (!saveButton.show) {
      return null;
    }

    if (saveButton.type === 'simple') {
      return (
        <RMSButton
          label={saveButton.label || 'Save'}
          color={saveButton.color || 'secondary'}
          className={saveButton.className}
          prefixIcon={saveButton.icon}
          variant={saveButton.variant}
          onClick={() => {
            onSave?.();
          }}
          disabled={saveDisabled}
        />
      );
    }

    return (
      <RMSFabIconButton
        icon={<SaveIcon />}
        color={saveButton.color || 'secondary'}
        tooltip={saveButton.label || 'Save'}
        onClick={onSave}
        disabled={saveDisabled}
        className={`dialog-save-button ${saveButton.className || ''}`}
      />
    );
  };

  const renderCancelButton = () => {
    if (!cancelButton.show) {
      return null;
    }
    if (cancelButton.type === 'simple') {
      return (
        <RMSButton
          label={cancelButton.label || 'Cancel'}
          color={cancelButton.color || 'secondary'}
          className={cancelButton.className}
          prefixIcon={cancelButton.icon}
          variant={cancelButton.variant}
          onClick={handleCancelClick}
        />
      );
    }

    return (
      <RMSFabIconButton
        icon={<CancelIcon />}
        color={cancelButton.color || 'secondary'}
        tooltip={cancelButton.label || 'Cancel'}
        onClick={handleCancelClick}
        className={`dialog-cancel-button ${cancelButton.className || ''}`}
      />
    );
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={handleDialogClose}
        maxWidth={maxWidth}
        fullWidth={fullWidth}
        className={clsx('rms-common-dialog', dialogClassName)}>
        {loading && <FormSpinner />}

        <DialogTitle className="dialog-title">
          <div className="dialog-header">
            <span className="dialog-heading">{title}</span>
            <div className="header-right">
              {headerActions}
              <RMSIconButton
                icon={<CloseIcon />}
                onClick={handleCancelClick}
                className="dialog-close-icon"
              />
            </div>
          </div>
        </DialogTitle>

        <DialogContent className={`dialog-content ${className}`}>{children}</DialogContent>

        <DialogActions className="dialog-footer">
          {customButtons}
          {renderCancelButton()}
          {renderSaveButton()}
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RMSCommonDialog;

// ---------- How to Use -------------------
// saveButton = {
//   show: true,
//   type: 'fab-icon' || 'simple',
//   color: 'default' || 'inherit' || 'primary' || 'secondary',
//   label: 'Save',
//   className: '',
//   variant     : 'contained' | 'outlined' | 'text'
// }
